import { Component, OnInit } from '@angular/core';

import { AuthenicationService } from '../../_services/authenication.service';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
})
export class UserprofileComponent implements OnInit {
  userdetaild: string;

  constructor(private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService) { }

  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
  }

}
